import { Container } from "../../styles/signup/success.page";
import { isMobile } from "react-device-detect";


export default function SuccessSignUpPage() {
  return (
    <Container>
      <div className="inner page_inner">
        <strong className={isMobile ? 'fs20' : 'fs30'}><strong className="green">셀러가드</strong> 가족이 되신 것을 환영합니다.</strong>
        <p className={isMobile ? 'fs16' : 'fs20'}>이제 지식재산권 걱정 없이, 사업만 열심히 하시도록 최선을 다해 지켜드리겠습니다.</p>
      </div>
    </Container>
  )
}